import React from 'react';
import { PrivacyPolicyReacceptanceModal } from './PrivacyPolicyReacceptanceModal';
import { useConsentGate } from './useConsentGate';

export const ConsentGate: React.FC = () => {
    const { needsReacceptance } = useConsentGate();
    if (!needsReacceptance) return null;
    return <PrivacyPolicyReacceptanceModal />;
};
